import React from "react";
import Navbar from "../layout/Navbar";

const AdminNavbar = () => {
  return (
    <Navbar
      type="관리자"
      menus={[
        // {
        //   name: "MY홈",
        //   link: "/admin/home",
        //   className: "home",
        // },
        {
          name: "시험실",
          link: "/admin/home",
          className: "exam",
        },
        // {
        //   name: "모니터링",
        //   link: "/admin/home",
        //   className: "monitoring",
        // },
        {
          name: "문항",
          link: "/admin/question",
          className: "question",
        },
        // {
        //   name: "문항 프리셋",
        //   link: "/admin/preset",
        //   className: "question",
        // },
        // {
        //   name: "접수페이지 설정",
        //   link: "/admin/setting",
        //   className: "statistics",
        // },
        {
          name: "계정관리",
          link: "/admin/account",
          className: "account",
        },
      ]}
    />
  );
};

export default AdminNavbar;
